import { DEFAULT_STATE, MAX_OVERALL_VALUES } from "../products/types";
import type { SortOption, UiState } from "../products/types";

function isSortOption(value: string | null): value is SortOption {
  return value === "overall-asc" || value === "overall-desc" || value === "price-asc" || value === "price-desc";
}

export function readStateFromQuery(categories: string[]): UiState {
  const params = new URLSearchParams(window.location.search);
  const category = params.get("category");
  const maxOverall = params.get("maxOverall");
  const sortBy = params.get("sortBy");

  const safeCategory = category && categories.includes(category) ? category : DEFAULT_STATE.category;
  const safeMaxOverall =
    maxOverall && (MAX_OVERALL_VALUES as readonly string[]).includes(maxOverall)
      ? maxOverall
      : DEFAULT_STATE.maxOverall;

  return {
    category: safeCategory,
    maxOverall: safeMaxOverall,
    sortBy: isSortOption(sortBy) ? sortBy : DEFAULT_STATE.sortBy
  };
}

export function writeStateToQuery(state: UiState): void {
  const params = new URLSearchParams();
  params.set("category", state.category);
  params.set("maxOverall", state.maxOverall);
  params.set("sortBy", state.sortBy);
  const query = params.toString();
  window.history.replaceState({}, "", `${window.location.pathname}?${query}`);
}
